import styled from 'styled-components';
import { TAB_ALIGNMENT } from '../../UtilityHeader/constants.js';
import { BREAKPOINTS } from '../../../spacing/index.js';
import { SIGN_IN_VARIANT, TAB_VARIANT, LANG_VARIANT } from '../constants.js';
import { isAccordion } from '../utils.js';
import { typography } from '../../../typography/typography.js';

// Styling for components shared by UtilityHeader and SideNav
var List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__List",
  componentId: "sc-b07kt2-0"
})(["margin:0;padding:0;list-style:none;"]);
var HeaderButtonComponent = /*#__PURE__*/styled.button.attrs(function (_ref) {
  var _ref$hasIcon = _ref.hasIcon,
    hasIcon = _ref$hasIcon === void 0 ? true : _ref$hasIcon;
  return {
    // all buttons by default have icons, but when using the generic 'HeaderButton' component,
    // users have the option to not specify one
    hasIcon: hasIcon
  };
}).withConfig({
  displayName: "styledComponents__HeaderButtonComponent",
  componentId: "sc-b07kt2-1"
})(["font-family:", ";font-size:", ";font-weight:", ";display:flex;align-items:center;justify-content:center;cursor:pointer;text-decoration:none;height:", ";padding:0 12px;margin:0;background-color:transparent;border-width:", ";border-style:solid;border-color:", ";color:", ";:hover,:focus{background-color:", ";}@media (max-width:", "px){border:none;font-size:", ";font-weight:", ";width:100%;height:60px;padding-right:16px;padding-left:", ";text-align:left;align-items:center;justify-content:left;}"], typography.fontFamily, typography.fontSizeSmall, typography.fontWeightDemibold, function (_ref2) {
  var theme = _ref2.theme;
  return theme.utilityHeader.headerButton.height;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "0 0 0 ".concat(theme.utilityHeader.headerButton.borderWidth);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sideNav.mobile.color;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sideNav.mobile.backgroundColor;
}, BREAKPOINTS.MAX_1024, typography.fontSize, typography.fontWeightNormal, function (_ref7) {
  var hasIcon = _ref7.hasIcon;
  return hasIcon ? '0' : '20px';
});
process.env.NODE_ENV !== "production" ? HeaderButtonComponent.displayName = 'HeaderButtonComponent' : void 0;
var IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-b07kt2-2"
})(["display:flex;justify-content:center;@media (max-width:", "px){min-width:56px;}"], BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : void 0;
var LabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__LabelWrapper",
  componentId: "sc-b07kt2-3"
})(["margin-left:", ";@media (max-width:", "px){margin-left:0;}"], function (_ref8) {
  var hasIcon = _ref8.hasIcon;
  return hasIcon ? '10px' : '0';
}, BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? LabelWrapper.displayName = 'LabelWrapper' : void 0;

// Styled components for SignIn
var SignInComponent = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__SignInComponent",
  componentId: "sc-b07kt2-4"
})(["", ""], function (_ref9) {
  var isSignedIn = _ref9.isSignedIn,
    variant = _ref9.variant,
    theme = _ref9.theme;
  var marginLeftRight = '16px';
  if (variant === SIGN_IN_VARIANT.OUTLINE) {
    return "\n      min-width: 90px;\n      margin: 0 12px;\n      justify-content: center;\n      border: 2px solid ".concat(theme.colorPalette.accentColor.shade_default, ";\n      :hover,\n      :focus {\n        color: ").concat(theme.colorPalette.neutralColors.light.shade_white, ";\n        background-color: ").concat(theme.colorPalette.accentColor.shade_default, ";\n      }\n      background-color: ").concat(theme.colorPalette.neutralColors.light.shade_white, ";\n      @media (max-width: ").concat(BREAKPOINTS.MAX_1024, "px) {\n        width: calc(100% - 2*").concat(marginLeftRight, ");\n        margin: 18px ").concat(marginLeftRight, ";\n      }\n      ").concat(LabelWrapper, " {\n        margin: 0;\n      }\n      ");
  }
  return "\n    border-left-width: ".concat(isSignedIn ? '1px' : '0', ";\n    border-bottom: none;\n    background-color: ").concat(isSignedIn ? 'transparent' : theme.colorPalette.secondaryColors.two.shade_light_1, ";\n    color: ").concat(isSignedIn ? theme.sideNav.mobile.color : theme.colorPalette.neutralColors.dark.shade_light_1, ";\n    :hover,\n    :focus {\n      background-color: ").concat(isSignedIn ? theme.colorPalette.neutralColors.dark.shade_default : theme.colorPalette.secondaryColors.two.shade_default, ";\n    }\n    @media (max-width: ").concat(BREAKPOINTS.MAX_1024, "px) {\n      :hover {\n        background-color: ").concat(isSignedIn ? 'transparent' : theme.colorPalette.secondaryColors.two.shade_default, ";\n      }\n    }\n    ");
});
process.env.NODE_ENV !== "production" ? SignInComponent.displayName = 'SignInComponent' : void 0;

// styled components for MenuItem
var MenuList = /*#__PURE__*/styled(List).withConfig({
  displayName: "styledComponents__MenuList",
  componentId: "sc-b07kt2-5"
})(["min-width:120px;max-width:172px;background-color:", ";border-style:solid;border-color:", ";border-width:2px;@media (max-width:", "px){max-width:100%;border:none;}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? MenuList.displayName = 'MenuList' : void 0;
var MenuItemWrapper = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__MenuItemWrapper",
  componentId: "sc-b07kt2-6"
})(["border-bottom:", ";&:last-of-type{border:none;}@media (max-width:", "px){border-bottom-width:1px;}"], function (_ref12) {
  var theme = _ref12.theme;
  return "2px solid ".concat(theme.colorPalette.neutralColors.light.shade_default);
}, BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? MenuItemWrapper.displayName = 'MenuItemWrapper' : void 0;
var MenuItemComponent = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__MenuItemComponent",
  componentId: "sc-b07kt2-7"
})(["font-family:", ";font-size:", ";font-weight:", ";box-sizing:border-box;text-align:left;cursor:pointer;width:100%;min-height:48px;padding:12px;background-color:", ";border:none;color:", ";:hover,:focus{background-color:", ";}display:flex;align-items:center;text-decoration:none;@media (max-width:", "px){font-size:", ";min-height:", ";padding-left:56px;padding-right:16px;", "}"], typography.fontFamily, typography.fontSizeSmall, typography.fontWeightNormal, function (_ref13) {
  var theme = _ref13.theme,
    $isSelected = _ref13.$isSelected;
  return $isSelected ? theme.utilityHeader.menu.active.backgroundColor : 'transparent';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.utilityHeader.menu.active.backgroundColor;
}, BREAKPOINTS.MAX_1024, typography.fontSize, function (_ref16) {
  var theme = _ref16.theme;
  return theme.sideNav.mobile.item.height;
}, function (_ref17) {
  var $isSelected = _ref17.$isSelected,
    theme = _ref17.theme;
  return $isSelected && "color: ".concat(theme.colorPalette.neutralColors.dark.shade_default, " !important;");
});
process.env.NODE_ENV !== "production" ? MenuItemComponent.displayName = 'MenuItemComponent' : void 0;

// Styled components for SearchField
var SearchFieldWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SearchFieldWrapper",
  componentId: "sc-b07kt2-8"
})(["display:flex;background-color:transparent;align-items:center;width:100%;height:", ";color:", ";input{color:inherit;::placeholder{color:inherit;}}"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.sideNav.mobile.searchField.height;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.sideNav.mobile.color;
});
process.env.NODE_ENV !== "production" ? SearchFieldWrapper.displayName = 'SearchFieldWrapper' : void 0;

// Styled components for Tabs
var TabList = /*#__PURE__*/styled(List).withConfig({
  displayName: "styledComponents__TabList",
  componentId: "sc-b07kt2-9"
})(["display:flex;padding-right:8px;flex-grow:1;justify-content:", ";height:100%;@media (max-width:", "px){height:50px;justify-content:left;background-color:", ";}"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.utilityHeader.tab.alignment === TAB_ALIGNMENT.LEFT ? 'left' : 'flex-end';
}, BREAKPOINTS.MAX_1024, function (_ref21) {
  var theme = _ref21.theme;
  return isAccordion(theme) ? theme.colorPalette.neutralColors.dark.shade_light_2 : 'transparent';
});
process.env.NODE_ENV !== "production" ? TabList.displayName = 'TabList' : void 0;
var TabItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__TabItem",
  componentId: "sc-b07kt2-10"
})(["display:flex;align-items:center;padding:0 16px;height:100%;", " &:first-of-type{padding-left:20px;}@media (max-width:", "px){&:first-of-type{padding-left:16px;}}"], function (_ref22) {
  var variant = _ref22.variant,
    theme = _ref22.theme;
  if (variant === TAB_VARIANT.NO_LINE) {
    return "\n    :not(:last-of-type) {\n      background: linear-gradient(\n        ".concat(theme.colorPalette.neutralColors.dark.shade_light_4, ",\n        ").concat(theme.colorPalette.neutralColors.dark.shade_light_4, "\n      )\n      no-repeat right/1px 20px;\n      @media (max-width: ").concat(BREAKPOINTS.MAX_1024, "px) {\n        background: linear-gradient(\n          ").concat(theme.colorPalette.neutralColors.light.shade_default, ",\n          ").concat(theme.colorPalette.neutralColors.light.shade_default, "\n        )\n        no-repeat right/1px 20px;\n      }\n    }\n    ");
  }
  return '';
}, BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? TabItem.displayName = 'TabItem' : void 0;
var TabComponent = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__TabComponent",
  componentId: "sc-b07kt2-11"
})(["font-family:", ";font-size:", ";font-weight:", ";text-decoration:none;display:flex;align-items:center;background-color:transparent;box-sizing:border-box;cursor:pointer;margin:0;padding:0;color:inherit;&:hover{text-shadow:", ";}@media (max-width:", "px){font-size:", ";height:100%;}border-color:", ";border-style:solid;", ""], typography.fontFamily, typography.fontSizeSmall, function (_ref23) {
  var $isSelected = _ref23.$isSelected;
  return $isSelected ? typography.fontWeightDemibold : typography.fontWeightLight;
}, function (_ref24) {
  var $isSelected = _ref24.$isSelected,
    theme = _ref24.theme;
  return $isSelected ? 'none' : "0px 0px 0px ".concat(theme.colorPalette.neutralColors.light.shade_white, ",\n0px 0px 0px ").concat(theme.colorPalette.neutralColors.light.shade_white);
}, BREAKPOINTS.MAX_1024, typography.fontSize, function (_ref25) {
  var $isSelected = _ref25.$isSelected,
    theme = _ref25.theme;
  return $isSelected ? theme.colorPalette.primaryColors.main.shade_default : 'transparent';
}, function (_ref26) {
  var $isSelected = _ref26.$isSelected,
    variant = _ref26.variant,
    theme = _ref26.theme;
  if (variant === TAB_VARIANT.NO_LINE) {
    return "\n    border-width: 0 0 2px;\n    font-size: ".concat(typography.fontSize, ";\n    font-weight: ").concat(typography.fontWeightDemibold, ";\n    @media (max-width: ").concat(BREAKPOINTS.MAX_1024, "px) {\n      font-size: ").concat(typography.fontSizeSmall, ";\n      font-weight: ").concat(typography.fontWeightNormal, ";\n      border: none;\n      min-height: 100%;\n      color: ").concat($isSelected ? theme.colorPalette.neutralColors.dark.shade_default : theme.colorPalette.neutralColors.light.shade_dark_3, ";\n    }\n    ");
  }
  return "\n  height: 100%;\n  border-width: 4px 0 0;\n  @media (max-width: ".concat(BREAKPOINTS.MAX_1024, "px) {\n    border-width: 0 0 4px;\n    color: ").concat(theme.sideNav.mobile.color, ";\n  }\n  ");
});
process.env.NODE_ENV !== "production" ? TabComponent.displayName = 'TabComponent' : void 0;

// Styled components for Lang
var LangComponent = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__LangComponent",
  componentId: "sc-b07kt2-12"
})(["@media (max-width:", "px){font-size:", ";}"], BREAKPOINTS.MAX_1024, function (_ref27) {
  var variant = _ref27.variant;
  return variant === LANG_VARIANT.SMALL ? typography.fontSizeSmall : typography.fontSize;
});
process.env.NODE_ENV !== "production" ? LangComponent.displayName = 'LangComponent' : void 0;

// Styled components for Lang
var LangList = /*#__PURE__*/styled(TabList).withConfig({
  displayName: "styledComponents__LangList",
  componentId: "sc-b07kt2-13"
})(["", "{", " ", "{font-size:", ";font-weight:", ";border:none;min-height:100%;padding:0;color:", ";}}"], MenuItemWrapper, function (_ref28) {
  var theme = _ref28.theme;
  return "\n        border: 0;\n        padding: 0 16px;\n        :not(:last-of-type) {\n          background: linear-gradient(\n            ".concat(theme.colorPalette.neutralColors.light.shade_default, ",\n            ").concat(theme.colorPalette.neutralColors.light.shade_default, "\n          )\n          no-repeat right/1px 20px;\n        }\n        ");
}, MenuItemComponent, typography.fontSizeSmall, typography.fontWeightNormal, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
});
process.env.NODE_ENV !== "production" ? LangComponent.displayName = 'LangComponent' : void 0;

// SkipLinks styled components
var SkipLink = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__SkipLink",
  componentId: "sc-b07kt2-14"
})(["position:absolute;overflow:hidden;padding:0;border:none;width:0;transform:translateX(-50%);z-index:5;top:0;background-color:", ";:focus,:active{font-family:", ";font-size:", ";font-weight:600;color:", ";border:", ";display:flex;align-items:center;justify-content:center;left:50%;width:220px;height:40px;@media (max-width:", "px){height:60px;}}:hover{color:", ";cursor:pointer;}"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.utilityHeader.main.backgroundColor;
}, typography.fontFamily, typography.fontSizeSmall, function (_ref31) {
  var theme = _ref31.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref32) {
  var theme = _ref32.theme;
  return "3px solid ".concat(theme.colorPalette.primaryColors.main.shade_default);
}, BREAKPOINTS.MAX_1024, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
});
process.env.NODE_ENV !== "production" ? SkipLink.displayName = 'SkipLink' : void 0;

export { HeaderButtonComponent, IconWrapper, LabelWrapper, LangComponent, LangList, MenuItemComponent, MenuItemWrapper, MenuList, SearchFieldWrapper, SignInComponent, SkipLink, TabComponent, TabItem, TabList };
